module.exports = __webpack_public_path__ + "img/e-commerce-2.29322da.jpeg";